import { Dispatch } from "redux"
import { ActionType } from "../action-types"
import { Action } from "../actions/index"

export const langValueState = (langValue: string) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_LANG_VALUE,
            payload: langValue
        })
    }
}

export const freezScreenState = (mode: boolean) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_FREEZ_SCREEN,
            payload: mode
        })
    }
}

export const alertMessageState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_ALERT_MESSAGE,
            payload: data
        })
    }
}

export const alertHideState = (mode: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_ALERT_MESSAGE,
            payload: mode
        })
    }
}


export const tableListState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_TABLE_LIST,
            payload: data
        })
    }
}
export const tableInvoicState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_TABLE_INVOICE,
            payload: data
        })
    }
}


export const invoiceState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_INVOICE_DATA,
            payload: data
        })
    }
}

export const branchState = (data: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_BRANCH_DATA,
            payload: data
        })
    }
}

export const setLoginState = (token: any, urlToken: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_LOGIN,
            payload: token,
            stateUrlToken:urlToken
        })
    }
}
export const setLogOut = () => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_LOGOUT,
        })
    }
}
export const tablesTypeState = (res: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_TABLES_TYPE,
            payload: res
        })
    }
}
export const tableInfoState = (res: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_TABLE_INFO,
            payload: res
        })
    }
}  

export const customTableSearchModeState = (res: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_CUSTOM_TABLE_SEARCH_MODE,
            payload: res
        })
    }
}  

export const setInvoiceMarkedpopup = (res: any) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.SET_InvoiceMarkedpopup,
            payload: res
        })
    }
} 